import React from 'react';

export const Logout: React.FC = () => {
  return (
    <svg
      fill='none'
      height='18'
      viewBox='0 0 18 18'
      width='18'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 2.31925H8C8.55 2.31925 9 1.8897 9 1.3647C9 0.839702 8.55 0.410156 8 0.410156H2C0.9 0.410156 0 1.26925 0 2.31925V15.6829C0 16.7329 0.9 17.592 2 17.592H8C8.55 17.592 9 17.1624 9 16.6374C9 16.1124 8.55 15.6829 8 15.6829H2V2.31925Z'
        fill='#051224'
      />
      <path
        d='M17.65 8.66698L14.86 6.00379C14.54 5.69834 14 5.90834 14 6.33788V8.04652H7C6.45 8.04652 6 8.47607 6 9.00107C6 9.52607 6.45 9.95561 7 9.95561H14V11.6642C14 12.0938 14.54 12.3038 14.85 11.9983L17.64 9.33516C17.84 9.15379 17.84 8.84834 17.65 8.66698Z'
        fill='#051224'
      />
    </svg>
  );
};
